import React, { useState } from "react";
import { BirthdayAssortWithSteps } from "../../../models/BirthDaysModels/BirthdayAssortWithSteps";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  assorts: BirthdayAssortWithSteps[];
  selectedAssort: BirthdayAssortWithSteps;
  onSelectAssort: (value: BirthdayAssortWithSteps) => void;
  handleStep: (step: number) => void;
}

const FirstStep: React.FC<IProps> = ({ assorts, onSelectAssort, handleStep }: IProps) => {
  const { t } = useTranslation();
  const [mainAssort, setMainAssort] = useState(99);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ marginBottom: "10px" }}>
        <div className="alert alert-yellow alert-big alert-thin" style={{ marginBottom: "16px" }}>
          {t("ze_wzgledu_na_duze_zainteresowanie_wprowadzilismy_system_do_samodzielnego_skladania_rezerwacji")}
        </div>
      </Grid>
      <div className="first-step-assort-container flex-start-center flex-wrap">


      {assorts?.map((item: BirthdayAssortWithSteps, index: number) => (
          <div key={index} className={`first-step-assort`}>
            {item.picture.length > 3 && <div className="img" style={{ backgroundImage: `url(${item.picture})` }}></div>}
          
            <div className="text">
              <h5>{item.name}</h5>
              <p className="text-description" dangerouslySetInnerHTML={{ __html: item.description }}></p>
            </div>
            <EAButton
              title={mainAssort === index ? t("wybrano") : t("wybierz")}
              onClick={() => {
                onSelectAssort(item);
                setMainAssort(index);
                handleStep(2);
              }}
              fullWidth
              variant={mainAssort === index ? "filled" : "outlined"}
            />
          </div>
      ))}
            </div>
    </Grid>
  );
};

export default FirstStep;
